module.exports = __webpack_public_path__ + "static/media/18.e3ea3480.jpg";